import React, {createContext, useReducer, useEffect} from 'react';
import {LOCAL_STORAGE} from "../LocalStorage";
import AuthReducer from "../AuthProvider/AuthReducer";
import PUBLIC_ROUTES from "../../routes/PublicRoutes";

import {
    LOGIN,
    LOGOUT,
    UPDATE_AUTH,
    UPDATE_AUTH_TOKEN,
} from "./types";
import PRIVATE_ROUTES from "../../routes/PrivateRoutes";
import fetchWrapper from "../../utils/fetch/fetchWrapper";

export const AuthContext = createContext({})

const AuthProvider = (props) => {

    const initialState = {
        auth: null,
        authToken: '',
        logged: false
    };

    const [state, dispatch] = useReducer(AuthReducer, initialState);

    useEffect(() => {
        const auth = JSON.parse(localStorage.getItem(LOCAL_STORAGE.AUTH))
        const authToken = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)
        if (auth && authToken) {
            dispatch({
                type: LOGIN,
                payload: {
                    user: auth,
                    token: authToken,
                }
            })


        }
    }, [])


    const login = (credentials, setError) => {
        fetchWrapper()
          .doPost({
              url: "/login",
              body:{
                  email: credentials.email,
                  password: credentials.password,
                  group: credentials.group,
              },
              onSuccess: async (response) => {
                    dispatch({
                        type: LOGIN,
                        payload: response.data
                    })
                    window.location.href = PRIVATE_ROUTES.DASHBOARD.path;
              },
              onError: (response) => {
                  alert(response.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
    }

    const logout = () => {
        dispatch({
            type: LOGOUT
        })
        window.location.href = PUBLIC_ROUTES.HOME.path;
    }

    const updateAuth = (auth) => {
        dispatch({
            type: UPDATE_AUTH,
            payload: auth
        })
    }

    const updateAuthToken = (authToken) => {
        dispatch({
            type: UPDATE_AUTH_TOKEN,
            payload: authToken
        })
    }

    return (
        <AuthContext.Provider value={{
            auth: state.auth,
            authType: state.authType,
            authToken: state.authToken,
            logged: state.logged,
            login,
            logout,
            updateAuth,
            updateAuthToken,
        }}>
            {props.children}

        </AuthContext.Provider>
    )
}

export default AuthProvider;
